import { render, staticRenderFns } from "./opTableServerSide.vue?vue&type=template&id=08a876c0&"
import script from "./opTableServerSide.vue?vue&type=script&lang=ts&"
export * from "./opTableServerSide.vue?vue&type=script&lang=ts&"
import style0 from "./opTableServerSide.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports